import React from 'react';
import AppBaseComponent from "../../../components/AppBaseComponent";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {Chart} from "react-google-charts";
import Ax from "../../../components/hoc/Ax";
import Loader from "../../../components/ui/Loader/Loader";
import TapSelect from "../../../components/ui/TapSelect";
import HttpAPICall from '../../../services/HttpAPICall';
import tapIcon from "../../../services/TapIcon";
import * as actions from "../../../store/actions/index"
import moment from "moment";
import TapApiUrls, { IAM_API_BASE_URL_2, IAM_API_BASE_URL_3 } from "../../../services/TapApiUrls";
import TapColorCodes from "../../../services/TapColorCodes";
import Status from "../../../components/ui/Status";
import UpdateMyDashboardForm from "../../settings/configurationGeneral/myDashboard/UpdateMyDashboardForm";
import DateService from '../../../services/DateService';

class TaskActivity extends AppBaseComponent {

    constructor() {
        super();
        this.state                      =   {
            iam_user_sites              :   [],
            all_periods                 :   [],
            taskActivityForm              :   {search_site_id : '', period   :   'current_month'},
            loading                     :   false,
            data                        :   [],
            remark_day                  :   0,
            time                 :   '',
            not_active                  :   0,
            taskData                    :   []
        }
        this.updateMyDashboardRef      =   React.createRef();
        this.activity_wise_count_url    =   IAM_API_BASE_URL_3 + '/counterlog/activity_task/statuswisecount';
    }


    componentDidMount() {
        this.initilaizeFormFilter(this.props);
        if (localStorage.getItem('taskActivity')) {
            let taskActivityData = JSON.parse(localStorage.getItem('taskActivity'));
            if (taskActivityData) {
                let lastRefreshTime = moment(taskActivityData.time).format()
               let differenceInSeconds =   DateService.differenceInSeconds(moment(taskActivityData.time, 'DD-MM-YYYY HH:mm A').format());
               
                if (differenceInSeconds > 86400) {
                    localStorage.removeItem('taskActivity')
                    setTimeout(() => {
                        this.getTaskActivityListing();
                    }, 1000 * (this.props.indexProps ? this.state.indexProps : 3));
                } else {
                    this.setState({
                        data            :       taskActivityData.data,
                        time     :       taskActivityData.time,
                         
                })

                }
            }else{
                setTimeout(() => {
                    this.getTaskActivityListing();
                }, 1000 * (this.props.indexProps ? this.state.indexProps : 3));
            }
        } else {
            setTimeout(() => {
                this.getTaskActivityListing();
            }, 1000 * (this.props.indexProps ? this.state.indexProps : 3));
            
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.iam_user_sites !== this.props.iam_user_sites || nextProps.dashboard_filter_site_id !== this.props.dashboard_filter_site_id || nextProps.clearDashboardFilter !== this.props.clearDashboardFilter) {
            this.initilaizeFormFilter(nextProps);
        }
    }

    initilaizeFormFilter               =   (props)  =>  {
        if(props.iam_user_sites.length > 0) {
            this.setState({
                iam_user_sites           :   props.iam_user_sites ? props.iam_user_sites.map((s) => { return {value: s.id, label: `${s.site_name} (${s.site_code})`}}) : [],
                all_periods              :   props.all_periods ? props.all_periods.map((s) => { return {value: s.key, label: `${s.display}`}}) : [],
            }, () => {
                
                 if(props.dashboard_filter_site_id || props.clearDashboardFilter == 'yes'){
                   
                    this.setState({
                        taskActivityForm              :   {
                            search_site_id             :       props.dashboard_filter_site_id ?  props.dashboard_filter_site_id : '',
                            period                      :       'current_month'
                        },
                        
                    },() =>  this.getTaskActivityListing())
                }
            });
        }
    }

    getTaskActivityListing                =   (reload=false)  =>  {
        this.setState({loading: true});
        let params          =   {
            search_site_id: this.state.taskActivityForm && this.state.taskActivityForm.search_site_id ? this.state.taskActivityForm.search_site_id : '' ,
            date_range : this.state.taskActivityForm && this.state.taskActivityForm.period ? this.state.taskActivityForm.period : 'current_month' ,
            reload : reload ? 'reload' : false};
            
        HttpAPICall.withAthorization('GET', this.activity_wise_count_url, this.props.access_token, params, {}, (response) => {
            
            this.setState({
                data            :       response.data.data,
                time            :       response.data.time, 
            })
  
            if(this.state.taskActivityForm.period && this.state.taskActivityForm.period == 'current_month'){
                localStorage.setItem('taskActivity',JSON.stringify(response.data));
            }
            if(reload !== false){
                localStorage.setItem('taskActivity',JSON.stringify(response.data));
            }
            
        }).then(() => this.setState({ loading: false }));
    }

    pinMyDashboardHandler = (widgetData=null) => {
        this.updateMyDashboardRef.current.updateMyDashboardModalInit(widgetData,{key:"task_running_status",name:"Task"})
    }

  
    render                      =   ()  =>  {
        
          
        let filterObj           =   {};
         if(this.state.taskActivityForm){
            if(this.state.taskActivityForm.search_site_id){
                filterObj           =   {...filterObj , 'search_site_id' : this.state.taskActivityForm.search_site_id}
            }
            if(this.state.taskActivityForm.period){
                filterObj           =   {...filterObj , 'period' : this.state.taskActivityForm.period}
            }
     }

     let widgetData = this.props.widget_keys && this.props.widget_keys.length > 0 && this.props.widget_keys.find(st => {return("task_running_status" == st.key)}) ? this.props.widget_keys.find(st => {return(st.key == "task_running_status")})  : null;
       
        return (<div className="card mt-3">
            <div className="card-body">
                <div className="row">
                    <div className="col-5">
                        <h6 className="fw-bold primary_color">Task</h6>
                    </div>
                    <div className="col-3">
                        <TapSelect
                            isClearable={false}
                            placeholder="Select Period"
                            containerHeight="33px"
                            fontSize="93%"
                            options={this.state.all_periods}
                            value={this.state.all_periods.find(r => r.value === this.state.taskActivityForm.period)}
                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'taskActivityForm', 'period', () => this.getTaskActivityListing())}
                        />
                    </div>
                    <div className="col-3 p0">
                        <TapSelect
                            options={this.state.iam_user_sites}
                            isSearchable={true}
                            isClearable={true}
                            placeholder="All Sites"
                            containerHeight="33px"
                            fontSize="93%"
                            value={this.state.iam_user_sites.find(r => this.state.taskActivityForm.search_site_id == r.value)}
                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'taskActivityForm', 'search_site_id', () => this.getTaskActivityListing())}
                        />
                    </div>
                    <div className="col-1 px-0 mx-0 text-center">
                        <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-2 btn btn-light btn-block" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                        <ul className="dropdown-menu dropdown-menu-end">
                            <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={this.getTaskActivityListing}>Refresh</li>
                            <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => this.pinMyDashboardHandler(widgetData)}>{!widgetData ? "Pinned to My Dashboard" : "Unpinned from My Dashboard"}</li>
                        </ul>
                    </div>
                </div>

                <div className="row mt-2  align-items-center">
                    <div className="col-6">

                        <table className="table table-hover table-bordered table-borderless bg-white">
                            <thead className="table-secondary">
                                <tr className="text-center" >
                                    <th style={{ width: "55%" }} className="text-start">Activity Name</th>
                                    <th style={{ width: "15%" }}>InProgress</th>
                                    <th style={{ width: "15%" }}>Complete</th>
                                    <th style={{ width: "15%" }}>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading
                                    ? <tr><td colSpan={4} className="text-center"><Loader /></td></tr>
                                    :
                                    this.state.data && this.state.data.length > 0
                                        ? this.state.data.map((dt, key) => {
                                            let inprogressData = dt.data && dt.data.length > 0 ? dt.data.find(task => task.status == 'In-Progress') : null;
                                            let completeData = dt.data && dt.data.length > 0 ? dt.data.find(task => task.status == 'Complete') : null
                                            return (<tr className="text-center">
                                                <th className="text-start">{<Status color={TapColorCodes()}>{dt.activity_name ? dt.activity_name : "-"}</Status>} </th>
                                                <td className="link-primary cursor_pointer"> <Link target="_blank" to={{ pathname: "/task_transaction_list", search: "?" + new URLSearchParams({ ...filterObj, activity_id: dt.id,status:inprogressData && inprogressData.key ? inprogressData.key  : '' }).toString() }}>{inprogressData && inprogressData.total}</Link></td>
                                                <td className="link-primary cursor_pointer"> <Link target="_blank" to={{ pathname: "/task_transaction_list", search: "?" + new URLSearchParams({ ...filterObj, activity_id: dt.id,status:completeData && completeData.key ? completeData.key  : '' }).toString() }}>{completeData && completeData.total}</Link></td>
                                                <td className="link-primary cursor_pointer"><Link target="_blank" to={{ pathname: "/task_transaction_list", search: "?" + new URLSearchParams({ ...filterObj, activity_id: dt.id}).toString() }}>{completeData && inprogressData ? Number(inprogressData.total) + Number(completeData.total) : 0}</Link></td>
                                            </tr>)

                                        })
                                        : <tr ><th colSpan={4} className="text-center">No Record</th></tr>}
                            </tbody>
                        </table>
                    </div>
                    <div className="col-6 p0">
                        {this.state.loading
                            ? <Loader />
                            : (this.state.data && this.state.data.length > 0 ? (<Chart
                                chartType="PieChart"
                                // loader={<Loader />}
                                data={[['', '']].concat(this.state.data?.map((dt) => {
                                    let inprogressData = dt.data && dt.data.length > 0 ? dt.data.find(task => task.status == 'In-Progress') : null;
                                    let completeData = dt.data && dt.data.length > 0 ? dt.data.find(task => task.status == 'Complete') : null;
                                    let totalData = inprogressData && completeData ? inprogressData.total + completeData.total : 0;
                                    return [dt.activity_name, totalData];
                                }))}
                                options={{
                                    legend: { position: 'labeled', labeledValueText: 'both' },
                                    pieSliceText: 'none',
                                    sliceVisibilityThreshold: 0,
                                    slices: TapColorCodes(),
                                    chartArea: { width: '90%', height: '90%' },
                                }}
                                rootProps={{ 'data-testid': '1' }} />) : null)
                        }
                    </div>
                    <div className="col-sm-12 text-muted fs11">
                        Report as of {this.state.time}
                    </div>
                </div>
                <UpdateMyDashboardForm
                    ref={this.updateMyDashboardRef}
               />
            </div>
        </div>);
    }
    
}


const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        iam_user_sites          :   state.app && state.app.user_sites ? state.app.user_sites : [],
        all_periods             :   state.app && state.app.all_periods ? state.app.all_periods : [],
        widget_keys             :   state.app && state.app.user_info && state.app.user_info.widget_keys && state.app.user_info.widget_keys.length > 0 ? state.app.user_info.widget_keys : [],
    };
};

export default connect(mapStateToProps)(TaskActivity);
